import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"background":"linear-gradient(360deg, #eef4fc 50%, transparent 50%)"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 지금 소개 자료를 다운받아보세요 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 알츠가드 (뇌건강 테스트) | 새미톡 (인지강화게임) ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 알츠가드 서비스 PDF ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 새미톡 서비스 PDF ")

import { useDisplay } from "vuetify";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { xs, smAndDown, smAndUp } = useDisplay();

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_container, { style: {"max-width":"1200px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { style: {"background-color":"rgb(33, 81, 143)"} }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "elevation-0 py-4 mx-4 text-white",
                style: {"background-color":"transparent"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    align: "center",
                    justify: "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6",
                        class: _normalizeClass(["py-6", { 'text-center justify-center': _unref(smAndDown) }])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, {
                            class: _normalizeClass(["font-weight-medium pt-0", {
                    'text-h6': _unref(xs),
                    'text-h5': _unref(smAndUp),
                    ' justify-center': _unref(smAndDown),
                  }])
                          }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }, 8, ["class"]),
                          _createVNode(_component_v_card_text, { class: "text-subtitle-2 text-white py-0" }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_component_v_col, { cols: "auto" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            class: _normalizeClass({ 'pa-5 xs': _unref(xs), 'pa-6': _unref(smAndUp) }),
                            variant: "outlined",
                            rounded: "lg",
                            href: "/files/알츠가드 서비스소개서_웹용.pdf",
                            download: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "auto",
                        class: "pa-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            class: _normalizeClass({ 'pa-5 xs': _unref(xs), 'pa-6': _unref(smAndUp) }),
                            variant: "outlined",
                            rounded: "lg",
                            href: "/files/새미톡 서비스소개서_웹용.pdf",
                            download: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})